var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[_c('div',{ref:"chart",staticClass:"chart"}),(_vm.loading)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loader"}),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.loadingText))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }